import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from '@/components/ui/Spinner';

PrimaryButton.propTypes = {
  variant: PropTypes.oneOf(['default', 'inverted']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  children: PropTypes.node
};

export default function PrimaryButton(props) {
  const {
    variant = 'default',
    disabled = false,
    loading = false,
    loadingLabel = 'Loading...',
    className,
    href,
    children,
    ...rest
  } = props;

  const inverted = variant === 'inverted';
  const isDisabled = disabled || loading;
  const TagName = href ? 'a' : 'button';
  const target = href?.startsWith('/') ? undefined : '_blank';

  return (
    <TagName
      href={href}
      type={href ? undefined: "button"}
      target={target}
      className={classNames(
        `inline-flex items-center justify-center gap-1
         border-2 border-transparent
         text-[17px] font-bold leading-6
         px-4 py-3 rounded-full cursor-pointer
         focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2
         w-full md:w-auto min-h-[52px] md:min-h-10`,
        inverted ? 'bg-white text-cs-navy-800' : 'bg-cs-navy-800 text-white',
        !isDisabled && (inverted
          ? 'hover:bg-cs-blue-50 active:bg-cs-navy-100'
          : 'hover:bg-cs-navy-850 active:bg-cs-navy-900'),
        loading && 'opacity-70 cursor-wait',
        disabled && 'opacity-40 cursor-not-allowed pointer-events-none',
        className
      )}
      disabled={isDisabled}
      {...rest}
    >
      {loading ? (
        <>
          <Spinner />
          <span>{loadingLabel}</span>
        </>
      ) : (
        children
      )}
    </TagName>
  );
}
